import { SCENE_INTERACTION } from "../../constants/scene";
import { WEBRTC_EVENTS } from "../../constants/webrtc";
import { SOCKET_EVENTS } from "../../socket/Socket";
import { googleIceServers, rcIceServers } from "../engine/helpers/config";
import SimplePeer from "simple-peer";
import { CALL_VIEW, ONE_ON_ONE_UI } from "./constants";
import { CallingDialog } from "./OneOnOne/CallingDialog";
import { IncomingCallDialog } from "./OneOnOne/IncomingCallDialog";
import AudioAnalyserIndicator from "./AudioAnalyser/AudioAnalyserIndicator";
import { requestMediaPermissions } from "../engine/helpers/userMediaHelper";
import {
  CallCameraControlButton,
  CallChatControls,
  CallContainer,
  CallControls,
  CallHangupButton,
  CallMicControlButton,
  CallMinimizeButton,
  CallScreenSharingButton
} from "./OneOnOne/OneOnOneView";
import { exitFullscreen } from '../engine/helpers/worldHelpers';
import { SCENE_EVENTS } from "../MVC/EVENTS/ModelEvents";

const iceServers = [
  {
    urls: 'stun:159.89.4.1:3478'
  },
  {
    urls: 'turn:159.89.4.1:3478',
    username: "bagless",
    credential: "11Vh0vvHVj6LObpjnSXyGU%K1za7N1",
  }
];

const productionIceServers = [
  {
    urls: 'stun:165.227.128.104:3478'
  },
  {
    urls: 'turn:165.227.128.104:3478',
    username: "bagless",
    credential: "11Vh0vvHVj6LObpjnSXyGU%K1za7N1",
  }
];

export default class OneOnOneController {
  constructor({ model, socket }) {
    this.template = $(CallContainer.template());
    $("body").append(this.template);

    this.callContainer = new CallContainer();
    this.callContainer.init({ controller: this, model });

    this.callControls = $(CallControls.template());
    CallControls.attach(this.callControls)

    this.callChatControls = $(CallChatControls.template());
    CallChatControls.attach(this.callChatControls)
    CallChatControls.init({ controller: this, model })

    this.model = model;
    this.socket = socket;
    this.myInfo = this.model.socket.getUserData();
    this.me = null;
    this.call = null;
    this.peer;
    // Add screenPeer to manage separate screen sharing connection
    this.screenPeer = null;
    this.userIsInTheRoom;

    // Audio Analysis
    this.audioContext = null;
    this.localAudioIndicator = null;
    this.peerAudioIndicator = null;
    this.speakingThreshold = 5; // Adjust this threshold based on testing

    // User's own tracks and streams
    this._local1on1Stream = null;
    this._myDummyTrack = null;      // Canvas track for placeholder
    this._myCameraTrack = null;     // Camera track
    this._myAudioTrack = null;     // Camera track
    this._myScreenStream = null;    // Screen sharing stream

    // Peer's tracks and streams
    this._peerCompositeStream = null;  // Peer's camera stream
    this._peerScreenStream = null;  // Peer's screen sharing stream
    this._peerDummyTrackId = null;  // ID of peer's dummy track for identification
    this._peerScreenTrackId = null; // ID of peer's screen sharing track

    // Track current sharing state
    this._isSharingScreen = false;
    this._isReceivingScreenSharing = false;

    this._callView = CALL_VIEW.STANDARD;
    this._callViewBeforeScreenShare = CALL_VIEW.STANDARD;

    window.oneOnOneController = this;

    this._createEmptyVideoTrack();

    function containsSubstring(url, substring) {
      return url.includes(substring);
    }
    let url = window.location.host;
    let substring = "apprc";
    this.iceServers = productionIceServers;
    if (containsSubstring(url, substring)) {
      this.iceServers = iceServers
    }

    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_SOMEONE_REJECTED_YOUR_CALL, () => {
      this.callContainer.setPeerVideoStream(null)
      this.hangUpCall(true, true);
      this.leaveCall();

      // Hide calling dialog if visible
      if (this.callingDialog && this.callingDialog.isVisible) {
        this.callingDialog.hide();
      }
    });

    // HANDLE 1:1 VIDEO CALL INITIATION
    this.model.addEventListener(WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE, async (e) => {
      console.log('WEBRTC_VIDEO_ONE_ON_ONE event triggered')
      const { item } = e.data;
      // Prevent user to call itself: action possible via owner profile
      if (item.userId === this.myInfo.userId) {
        this.model.alert('error', $trans('error-calling-yourself'));
        return;
      }

      const knownOnline = !!(e.data && e.data.forceOnline) || this.model.isUserOnline(item.userId);
      if (!knownOnline) {
        this.placeOfflinePersonalCall(item);
        return;
      }

      if (this.model.isUserBusy(item.userId)) {
        this.model.alert('error', $trans('error-call-friend-busy'));
        return;
      }

      if (this.model.isUserInTour(item.userId)) {
        this.model.alert('error', $trans('error-call-friend-in-tour'));
        return;
      }

      if (this.model.activeOneOnOneCall) {
        this.model.alert('error', $trans('error-call-already-in-progress'));
        return;
      }

      const socketId = item.socketId || item.socket_id;
      if (!socketId) {
        this.placeOfflinePersonalCall(item);
        return;
      }
      item.socketId = socketId;

      // Cleanup meeting mode streams before starting 1:1 call
      if (this.model.streamController) {
        try {
          await this.model.streamController.cleanupAllStreams();
        } catch (error) {
          console.error("Error cleaning up meeting mode streams:", error);
          // Continue anyway to not block 1:1 call start
        }
      }

      // Cleanup tour mode streams before starting 1:1 call
      if (this.model.tourStreamController) {
        try {
          await this.model.tourStreamController.cleanupAllStreams();
        } catch (error) {
          console.error("Error cleaning up tour mode streams:", error);
          // Continue anyway to not block 1:1 call start
        }
      }

      if (!item.userName) {
        const listed = this.model.resolveOnlineUser(item.userId);
        if (listed) {
          item.userName = listed.userName;
          item.userAvatarUrl = item.userAvatarUrl || listed.userAvatarUrl;
        }
      }

      if ($(`.video_notification_from_${item.userId}`).length) {
        this.model.confirm(`${item.userName} ${$trans('confirm-already-calling-you-answer')}`, () => {
          $(`.video_notification_from_${item.userId}`).children('.call_cta').children('.respond_video_call').trigger('click');
        });
        return;
      }

      this.peerInfo = item;
      const constraints = {
        cameraDevice: $('#settings_camera').val(),
        microphoneDevice: $('#settings_microphone').val()
      }

      // Display calling popup
      this.displayCallingPopup(item.userName, item.userId);

      // Setup call parameters
      const scopeId = `${this.myInfo.userId}_${item.userId}`;
      const scopeName = `1:1 ${this.myInfo.userName} - ${item.userName}`;
      const withCamera = true; // TODO - grab this from some settings/dialog
      const withAudio = true; // TODO - grab this from some settings/dialog

      // Initialize WebRTC connection
      const callback = () => {
        callUser(socketId)
      }
      await this.start(
        'users',
        scopeId,
        scopeName,
        withCamera,
        withAudio,
        constraints,
        null,
        null,
        callback
      );

      try {
        this.model.activeOneOnOneCall = true;
        this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE })

        this.model.socket.updateOneOnOneStatus({ 'userVideoOn': this.model.userWantsCamera, 'on1on1Call': true });
      } catch (e) {
        console.error('Error when start 1:1 call', e)

        this.model.activeOneOnOneCall = false
        this.hangUpCall(true, true)
      }
    });

    this.model.addEventListener(SCENE_EVENTS.DEVICE_SETTINGS_CHANGED, async (e) => {
      if (!this.peer) {
        return;
      }

      const senders = this.peer._pc.getSenders();
      const videoSender = senders.find(sender => sender.track?.id === this._myCameraTrack.id);
      const audioSender = senders.find(sender => sender.track?.id === this._myAudioTrack.id);
      if (!videoSender || !audioSender) {
        console.error('No audio or video sender found to replace track');
        return
      }

      try {
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: this.model.view.deviceSettingsMenu.selected.camera.value },
          audio: { deviceId: this.model.view.deviceSettingsMenu.selected.microphone.value },
        })

        // Get old video tracks
        const oldCameraTrack = this._local1on1Stream.getVideoTracks().find((track) => track.id === this._myCameraTrack.id)
        const oldAudioTrack = this._local1on1Stream.getAudioTracks()[0]

        // Get new video tracks
        const newCameraTrack = newStream.getVideoTracks()[0]
        const newAudioTrack = newStream.getAudioTracks()[0]

        // replace old video track with new video track in sending stream
        await videoSender.replaceTrack(newCameraTrack)
        await audioSender.replaceTrack(newAudioTrack)

        // replace old video track with new video track in local stream
        // dummy track need to be after camera track, so that the <video> element display the camera track
        this._myCameraTrack = newCameraTrack
        this._myAudioTrack = newAudioTrack

        this._local1on1Stream.getTracks().forEach((track) => {
          this._local1on1Stream.removeTrack(track)
        })
        this._local1on1Stream.addTrack(this._myCameraTrack)
        this._local1on1Stream.addTrack(this._myAudioTrack)
        this._local1on1Stream.addTrack(this._myDummyTrack)

        // Stop old tracks
        oldCameraTrack.stop()
        oldAudioTrack.stop()

        this.callContainer.setOwnVideoStream(this._local1on1Stream)
      } catch (e) {
        console.error('Error when update device settings in 1-on-1', e)
      }
    })

    this.model.addEventListener(SCENE_EVENTS.SOMEONE_LEAVED_ROOM, (e) => {
      const payload = e.data;
      if (String(payload.userId) === String(this.peerInfo?.userId) && this.model.activeOneOnOneCall) {
        this.hangUpCall(true, true)
      }
    });

    // REJECT INCOMING 1:1 CALL
    $(document).on('click', '.reject_video_call', (e) => {
      console.log('reject_video_call');
      if (this.pendingOfflineCall && this.socket.getSocket()) {
        this.socket.getSocket().emit('personalCallDecline', { callId: this.pendingOfflineCall.callId });
        this.pendingOfflineCall = null;
      }

      this.incomingCallDialog?.hide()

      const index = $('.respond_video_call').index(e.target);
      const removeElement = $('.call_unique_class').eq(index).val();
      const scopeId = $('.call_scope_id').eq(index).val();
      this.removeNotification(removeElement);
      this.model.hideLoading();
      this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_CALL_REJECTED, data: { callInitiatorID: this.caller.userId, scopeId } });
    });

    // ANSWER INCOMING 1:1 CALL
    $(document).on('click', '.respond_video_call', async (e) => {
      if (this.model.chessGameMode) {
        this.model.confirm($trans('exit-chess-game'), async () => {
          this.model.forceQuitChessGame();
          await this.handleVideoCallResponse(e);
        })
        return;
      } else {
        await this.handleVideoCallResponse(e);
      }
    });

    const setCall = (data) => {
      this.call = data;
    }

    const setCallAccepted = () => {
      this.inCall = true;
    }
    const setCallEnded = () => {
      this.inCall = false;
    }

    socket.on('me', (id) => () => {
      console.log("MEEEE", id)
      this.me = id;
    });

    ///user is receiving the call
    socket.on('personalCallIncoming', (payload) => {
      this.showOfflineIncoming(payload);
    });
    socket.on('personalCallAccepted', (payload) => {
      if (!payload || payload.callId !== this.offlineCallId) {
        return;
      }
      this.offerCallId = payload.callId;
      this.offlineCallId = null;
      const item = {
        ...(this.offlinePeer || {}),
        userId: (this.offlinePeer && this.offlinePeer.userId) || payload.recipientId,
        socketId: payload.recipientSocketId,
      };
      this.model.dispatchEvent({
        type: WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE,
        data: { item, forceOnline: true },
      });
    });
    socket.on('personalCallResolved', (payload) => {
      if (!payload) {
        return;
      }
      const matches = payload.callId === this.offlineCallId
        || (this.pendingOfflineCall && payload.callId === this.pendingOfflineCall.callId);
      if (!matches) {
        return;
      }
      const mine = this.socket.getSocket() && payload.bySocketId === this.socket.getSocket().id;
      if (payload.status === 'answered' && mine) {
        return;
      }
      this.offlineCallId = null;
      this.pendingOfflineCall = null;
      if (this.callingDialog && this.callingDialog.isVisible) {
        this.callingDialog.hide();
      }
      if (this.incomingCallDialog && this.incomingCallDialog.isVisible) {
        this.incomingCallDialog.hide();
      }
    });

    socket.on('callUser', (payload) => {
      const { from, name, signal } = payload;
      if (!from || !signal) {
        return;
      }
      if (this.waitingSignalForCallId && payload.callId === this.waitingSignalForCallId) {
        setCall({ isReceivingCall: true, from, name: name, signal: signal });
        this.waitingSignalForCallId = null;
        this.pendingOfflineCall = null;
        this.handleVideoCallResponse({ target: this.incomingCallDialog && this.incomingCallDialog.template });
        return;
      }
      setCall({ isReceivingCall: true, from, name: name, signal: signal });
      ///TODO_WEBRTC
      // this.userIsInTheRoom = webrtc.iAmInTheRoom();
      const user = this.model.socket.getUserBySocketId(from) || {
        userId: payload.userId || from,
        userName: payload.userName || name || 'Caller',
        userAvatarUrl: payload.userAvatarUrl || '',
        socketId: from,
      };
      this.caller = user;
      this.callInitiatorID = from;
      const data = {
        withCamera: true,
        withSound: true,
        scopeId: "scopeId",
        scopeDisplayName: "scopeDisplayName",
      };

      // Import and initialize CallingDialog if not already done
      if (!this.incomingCallDialog) {
        this.incomingCallDialog = new IncomingCallDialog();
      }

      this.incomingCallDialog.initAndShow({ data, senderInfo: user, model: this.model });
    });

    socket.on('screenShareStarted', (payload) => {
      const { dummyTrackId, screenTrackId } = payload
      this._peerDummyTrackId = dummyTrackId
      this._peerScreenTrackId = screenTrackId

      this._isReceivingScreenSharing = true

      const peerDummyTrack = this._peerCompositeStream.getTracks()[2]
      if (!peerDummyTrack) {
        return
      }

      this._peerScreenStream = new MediaStream()
      this._peerScreenStream.addTrack(peerDummyTrack)

      // Display own screen in UI
      this.callContainer.setShareVideoStream(this._peerScreenStream)

      // Update UI
      this.enterScreenShareView()
    })

    // Add listener for when peer stops screen sharing
    socket.on('screenShareStopped', () => {
      console.log('Peer stopped screen sharing')

      this._isReceivingScreenSharing = false
      if (!this._peerScreenStream) {
        return
      }

      this.callContainer.setShareVideoStream(null)
      this.exitScreenShareView()
    });

    const callUser = (id) => {
      ///TODO_WEBRTC
      // this.userIsInTheRoom = webrtc.iAmInTheRoom();
      const stream = this._local1on1Stream;
      if (this.peer) {
        this.peer = null;
      }
      const currentTracks = stream.getTracks();
      const hasEmptyTrack = currentTracks.some(track => track.id === this._myDummyTrack?.id);
      if (this._myDummyTrack && !hasEmptyTrack) {
        console.log('Adding empty video track to stream in callUser', this._myDummyTrack);
        try {
          stream.addTrack(this._myDummyTrack);
        } catch (e) {
          console.error('Error adding empty track to stream:', e);
        }
      }

      const peer = new SimplePeer({
        initiator: true,
        trickle: false,
        stream,
        config: { iceServers: this.iceServers }
      });
      peer.on('signal', (data) => {
        const offerCallId = this.offerCallId;
        this.offerCallId = null;
        socket.getSocket().emit('callUser', {
          userToCall: id,
          signalData: data,
          from: this.me || socket.getSocket().id,
          name: this.myInfo.userName || '',
          userId: this.myInfo.userId,
          userName: this.myInfo.userName || '',
          userAvatarUrl: this.myInfo.userAvatarUrl || '',
          callId: offerCallId || undefined,
        });
      });
      peer.on('stream', (currentStream) => {
        console.log('[callUser] Receive stream ', currentStream)

        this._peerCompositeStream = currentStream;

        this.callContainer.setPeerVideoStream(currentStream, {
          callback: () => {
            this._initAudioIndicator('peer', currentStream);
          }
        });
      });
      peer.on('close', () => {
        if (this.model.activeOneOnOneCall) {
          this.hangUpCall(true, true);
        }
      });
      const callAcceptedCallback = (payload) => {
        ///TODO_WEBRTC
        // webrtc.leaveRoom();
        this.model.hideLoading();
        setCallAccepted(true);
        const signal = payload && payload.sdp ? payload : payload && payload.signal;
        if (this.peer && signal) {
          this.peer.signal(signal);
        }

        // SHOW 1:1 VIDEO LAYER
        this.callContainer.displayCallOverlay();

        // Hide calling dialog if visible
        if (this.callingDialog && this.callingDialog.isVisible) {
          this.callingDialog.hide();
        }

        socket.getSocket().off('callAccepted', callAcceptedCallback);
      }
      socket.getSocket().on('callAccepted', callAcceptedCallback);

      this.callContainer.setOwnVideoStream(stream);

      this.peer = peer;
      this.model.activeOneOnOneCall = true;
      this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE });
      this.model.socket.updateOneOnOneStatus({ 'userVideoOn': this.model.userWantsCamera, 'on1on1Call': true })
    };

    this.leaveCall = () => {
      if (!this.inCall) {
        return;
      }
      if (this._localStream) {
        $('#my-own-video-wrapper')
          .removeClass('on-1on1-call')
          .removeClass('hidden')
      }
      this.callContainer.setOwnVideoStream(null)
      this.callContainer.setPeerVideoStream(null)
      this.peerInfo = {};
      this.model.hideLoading()
      $('#one-on-one-video-call-peer-id').val('');

      // Destroy audio indicators
      if (this.localAudioIndicator) {
        this.localAudioIndicator.destroy();
        this.localAudioIndicator = null;
      }
      if (this.peerAudioIndicator) {
        this.peerAudioIndicator.destroy();
        this.peerAudioIndicator = null;
      }

      // Close AudioContext ONLY here, after stopping all analysers
      if (this.audioContext && this.audioContext.state !== 'closed') {
        console.log('Closing AudioContext in hangUpCall');
        this.audioContext.close().catch(e => console.error('Error closing AudioContext:', e));
        this.audioContext = null;
      }

      this.model.activeOneOnOneCall = false;
      this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE });
      setCallEnded(true);
      this.model.socket.getUsersObject()[this.model.config.userId].on1on1Call = false;
      this.model.dispatchEvent({ type: WEBRTC_EVENTS.HUNG_UP_CALL, });
      this.model.socket.updateOneOnOneStatus({ 'userVideoOn': this.model.userWantsCamera, 'on1on1Call': false })
    };

    this.addEventListeners()
  }

  addEventListeners() {
    CallMicControlButton.init({ controller: this })
    CallCameraControlButton.init({ controller: this })
    CallHangupButton.init({ controller: this, model: this.model })
    CallScreenSharingButton.init({ controller: this })
    CallMinimizeButton.init({ controller: this })
  }

  placeOfflinePersonalCall(item) {
    const io = this.socket.getSocket && this.socket.getSocket();
    if (!io || !io.connected) {
      this.model.alert('error', $trans('error-call-friend-offline'));
      return;
    }
    const routes = window.baglessNotificationRoutes || {};
    let settled = false;
    const timer = window.setTimeout(() => {
      if (!settled) {
        settled = true;
        this.model.alert('error', 'This call could not be started.');
      }
    }, 8000);
    io.emit('personalCallStart', {
      recipientId: item.userId,
      openPath: routes.callPath || '',
    }, (response) => {
      window.clearTimeout(timer);
      if (settled) {
        return;
      }
      settled = true;
      if (!response || !response.ok) {
        if (response && response.error === 'not_mutual') {
          this.model.alert('error', 'You can only call a mutual buddy.');
        } else if (response && response.error === 'busy') {
          this.model.alert('error', $trans('error-call-friend-busy'));
        } else {
          this.model.alert('error', 'This call could not be started.');
        }
        return;
      }
      if (response.mode === 'online' && response.socketId) {
        this.model.dispatchEvent({
          type: WEBRTC_EVENTS.WEBRTC_VIDEO_ONE_ON_ONE,
          data: {
            item: { ...item, socketId: response.socketId },
            forceOnline: true,
          },
        });
        return;
      }
      this.offlineCallId = response.callId;
      this.offlinePeer = item;
      this.displayCallingPopup(item.userName || 'Friend', item.userId);
    });
  }

  showOfflineIncoming(payload) {
    if (!payload || !payload.callId) {
      return;
    }
    if (this.pendingOfflineCall && this.pendingOfflineCall.callId === payload.callId) {
      return;
    }
    this.pendingOfflineCall = payload;
    this.caller = {
      userId: payload.callerId,
      userName: payload.callerName || 'Someone',
    };
    if (!this.incomingCallDialog) {
      this.incomingCallDialog = new IncomingCallDialog();
    }
    this.incomingCallDialog.initAndShow({
      data: {
        withCamera: true,
        withSound: true,
        scopeId: 'scopeId',
        scopeDisplayName: 'scopeDisplayName',
      },
      senderInfo: {
        userId: payload.callerId,
        userName: payload.callerName || 'Someone',
      },
      model: this.model,
    });
  }

  displayCallingPopup(peerUsername, id = false) {
    // Import and initialize CallingDialog if not already done
    if (!this.callingDialog) {
      this.callingDialog = new CallingDialog();
    }

    this.callingDialog.show(peerUsername);

    // Setup event listener for call cancellation if not already set
    if (!this._callingCancelListener) {
      this._callingCancelListener = true;
      $(document).on('calling:cancelled', () => {
        if (this.offlineCallId && this.socket.getSocket()) {
          this.socket.getSocket().emit('personalCallCancel', { callId: this.offlineCallId });
          this.offlineCallId = null;
        }
        this.hangUpCall(true, true);
        this.leaveCall();
        const classToBeRemoved = `video_notification_from_${this.myInfo.userId}`;
        this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_CALL_CANCELED, data: { classToBeRemoved } });
      });
    }
  }

  start = async (scopeType, scopeId = 1, scopeDisplayName = 'test scene', withCamera = true, withSound = true, constraints, removeElement = null, unique_id = null, callback) => {
    if (scopeType === 'users') {
      if (!navigator.mediaDevices.getUserMedia) {
        return alert('Ihr Gerät unterstützt keine Video/Audio Übertragung');
      }

      // Cleanup meeting mode streams before starting 1:1 call
      if (this.model.streamController) {
        try {
          await this.model.streamController.cleanupAllStreams();
        } catch (error) {
          console.error("Error cleaning up meeting mode streams:", error);
          // Continue anyway to not block 1:1 call start
        }
      }

      // Cleanup tour mode streams before starting 1:1 call
      if (this.model.tourStreamController) {
        try {
          await this.model.tourStreamController.cleanupAllStreams();
        } catch (error) {
          console.error("Error cleaning up tour mode streams:", error);
          // Continue anyway to not block 1:1 call start
        }
      }

      this._currentScopeType = scopeType;
      this._currentScopeId = scopeId;
      this._currentScopeDisplayName = scopeDisplayName;

      navigator.mediaDevices.getUserMedia({
        video: { deviceId: constraints.cameraDevice ? { exact: constraints.cameraDevice } : undefined },
        audio: { deviceId: constraints.microphoneDevice ? { exact: constraints.microphoneDevice } : undefined },
      })
        .then(stream => {
          this._local1on1Stream = stream;
          this._myCameraTrack = stream.getVideoTracks()[0];
          this._myAudioTrack = stream.getAudioTracks()[0];

          // Setup and start audio analysis for the local user
          this._initAudioIndicator('local', stream);

          this.callContainer.setOwnVideoStream(stream, {
            preprocess: (videoElement) => {
              const onLoaded1on1MetadataCallback = () => {
                this.model.attachSinkId(videoElement, $(".speakerSelect").val());
                this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_USER_STARTED_VIDEO, data: { scopeType, withCamera, withSound, scopeId, scopeDisplayName, peerInfo: this.peerInfo } });

                $("#my-own-video-wrapper").addClass('hidden');
                $('#my-own-video-wrapper').addClass('on-1on1-call');

                this.removeNotification(removeElement);
                $("#own-avatar-call").hide();

                this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_VIDEO_STATE_CHANGED, data: { 'userVideoOn': false, 'on1on1Call': true } });
                videoElement.removeEventListener('loadedmetadata', onLoaded1on1MetadataCallback);
              }

              videoElement.addEventListener('loadedmetadata', onLoaded1on1MetadataCallback);
            }
          });

          this.model.hideMediaDevices && this.model.getMediaDevices(); //TODO check what is this doing
          this.started1on1 = true;
          callback && callback()
        })
        .catch(err => {
          this.model.showSelfCheckModal();
          this._errorHandler(err);
          this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_FAILED_TO_START_USER_VIDEO });
        })
        .then(() => {
          this._sendData({
            'displayName': this.myInfo.userName,
            'uuid': this._uuid,
            'userId': this.myInfo.userId,
            'dest': 'all'
          });
        })
        .catch(this._errorHandler);
    }
    $("#grid-view-option").removeClass("disabled");
    this.model.activeOneOnOneCall = true;
    this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE });
    this.model.socket.updateOneOnOneStatus({ 'userVideoOn': this.model.userWantsCamera, 'on1on1Call': true })
  }

  removeNotification(removeElement) {
    removeElement !== null && $(`.${removeElement}`).remove();
    $('#notifications_holder').removeClass('expanded');
    const activeCalls = $("#video_notifications > .call_notification").length;
    $('#notification_toggle_button').attr('data-count', activeCalls);
    !activeCalls && $('#notification_toggle_button').hide();
  }

  hangUpCall = async (removePeers = true, dispatch = true) => {
    console.log('%c hangUpCall', 'color:red');

    // Force exit fullscreen if active
    this.exitScreenShareFullscreen();

    // Stop screen sharing if active
    if (this._isSharingScreen) {
      this.stopScreenSharing();
    }

    if (this.localAudioIndicator) {
      this.localAudioIndicator.destroy();
      this.localAudioIndicator = null;
    }
    if (this.peerAudioIndicator) {
      this.peerAudioIndicator.destroy();
      this.peerAudioIndicator = null;
    }
    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close().catch(e => console.error('Error closing AudioContext:', e));
      this.audioContext = null;
    }

    this.model.activeOneOnOneCall = false;
    await this._stop(removePeers, dispatch);

    $("#oneOnOneVideoContainer").removeClass('active');
    this.resetCallView()
    this.model.oneOnOneCallView = null
    CallControls.hide()
    CallChatControls.hide()
    this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE })

    $('#my-own-video-wrapper').removeClass('on-1on1-call');
    $('#my-own-video-wrapper').removeClass('hidden');

    this.callContainer.setOwnVideoStream(null)
    this.callContainer.setPeerVideoStream(null)
    this.peerInfo = {};
    // $("#gridToggle").addClass('hidden');

    this.model.hideLoading();

    // Clean up classes
    $('#my-own-video-wrapper-call .one-on-one__media').removeClass('speaking');
    $('#my-audio-indicator').removeClass('one-on-one__media__audio-indicator--active');
    $('#my-peer-video-wrapper-call .one-on-one__media').removeClass('speaking');
    $('#peer-audio-indicator').removeClass('one-on-one__media__audio-indicator--active');

    $('#one-on-one-video-call-peer-id').val('');
    this.leaveCall();
    this.model.activeOneOnOneCall = false;
    this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE });
    this.model.socket.updateOneOnOneStatus({ 'userVideoOn': this.model.userWantsCamera, 'on1on1Call': false })
  }

  _stop = async (removePears = true, dispatch = true) => {
    try {
      this._peerConnections = {};
      let stopped_streamId = false;
      if (removePears) {
        const streamId = this._local1on1Stream && this._local1on1Stream.id;
        this._detachCallVideos();
        this._closeCallPeer();
        this._releaseCallCapture();
        if (streamId) {
          stopped_streamId = this._formatStreamId(streamId);
        }
      }
      if (dispatch) {
        this._sendData({
          'stopConnection': true,
          'uuid': this._uuid,
          'userId': this.myInfo.userId,
          'dest': 'all',
          'stopped_streamId': stopped_streamId,
        });
      }

      this._currentScopeType = null;
      this._currentScopeId = null;
      this._currentScopeDisplayName = null;
      this.started1on1 = false;

      $("#grid-view-option").addClass("disabled");
      this.model.socket.updateOneOnOneStatus({ 'userVideoOn': this.model.userWantsCamera, 'on1on1Call': false })
    } catch (exception) {
      console.error('VRWebRtcController._stop()', exception);
    }
  }

  _detachCallVideos() {
    ['own-video-call', 'peer-video-call'].forEach((id) => {
      const video = document.getElementById(id);
      if (!video) {
        return;
      }
      try {
        video.pause();
      } catch (error) {
        // The element can already be paused.
      }
      video.srcObject = null;
    });
    const share = document.querySelector('#one-on-one__screen-share-container video');
    if (share) {
      try {
        share.pause();
      } catch (error) {
        // The element can already be paused.
      }
      share.srcObject = null;
    }
  }

  _closeCallPeer() {
    const peer = this.peer;
    this.peer = null;
    if (!peer) {
      return;
    }
    try {
      peer.removeAllListeners();
    } catch (error) {
      // The peer can already be destroyed when the remote side hangs up.
    }
    const connection = peer._pc;
    if (connection && connection.signalingState !== 'closed') {
      try {
        connection.getSenders().forEach((sender) => {
          if (sender.track && sender.track !== this._myDummyTrack) {
            sender.track.stop();
          }
        });
        connection.close();
      } catch (error) {
        // Closing still runs below if sender cleanup fails partway.
        try {
          connection.close();
        } catch (closeError) {
          // Already closed.
        }
      }
    }
    try {
      if (!peer.destroyed && !peer.destroying) {
        peer.destroy();
      }
    } catch (error) {
      // Local tracks are stopped in _releaseCallCapture.
    }
  }

  _releaseCallCapture() {
    const spare = this._myDummyTrack;
    const stopTrack = (track) => {
      if (!track || track === spare || track.readyState === 'ended') {
        return;
      }
      try {
        track.stop();
        track.enabled = false;
      } catch (error) {
        // The device is already released.
      }
    };
    const releaseElement = (video) => {
      if (!video) {
        return;
      }
      const stream = video.srcObject;
      if (stream && typeof stream.getTracks === 'function') {
        stream.getTracks().forEach(stopTrack);
      }
      try {
        video.pause();
      } catch (error) {
        // The element can already be paused.
      }
      video.srcObject = null;
    };

    releaseElement(document.getElementById('own-video-call'));
    releaseElement(document.getElementById('peer-video-call'));
    releaseElement(document.querySelector('#one-on-one__screen-share-container video'));

    if (this._local1on1Stream) {
      this._local1on1Stream.getTracks().forEach(stopTrack);
      this._local1on1Stream = null;
    }
    stopTrack(this._myCameraTrack);
    stopTrack(this._myAudioTrack);
    this._myCameraTrack = null;
    this._myAudioTrack = null;
    if (this._myScreenStream) {
      this._myScreenStream.getTracks().forEach(stopTrack);
      this._myScreenStream = null;
    }
  }

  _formatStreamId = (id) => {
    //firefox adding brackets
    let result;
    if (id.charAt(0) === "{") {
      result = id.slice(1, -1);
    } else {
      result = id;
    }
    return result;
  }

  _sendData(payload) {
    if (this._currentScopeId) {
      this.socket && this.socket.getSocket().emit('webRtcData', { ...payload, scopeId: this._currentScopeId, userId: this.myInfo.userId, userVideoOn: this.myInfo.userVideoOn });
    }
  }

  _ensureAudioContext = () => {
    // Create or resume the AudioContext
    // Browsers require user interaction to start/resume AudioContext
    // This often happens implicitly when getUserMedia is called, but good to be explicit.
    if (!this.audioContext || this.audioContext.state === 'closed') {
      console.log("Creating new AudioContext");
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    } else if (this.audioContext.state === 'suspended') {
      console.log("Resuming suspended AudioContext");
      this.audioContext.resume().catch(e => console.error("Error resuming AudioContext:", e));
    }
  }

  _initAudioIndicator = (type, stream) => {
    console.log(`Initializing audio indicator for: ${type}`);
    if (!stream) {
      console.warn(`Cannot init audio indicator for ${type}: stream is null`);
      return;
    }
    if (!stream.getAudioTracks().length || !stream.getAudioTracks().some(t => t.readyState === 'live')) {
      console.warn(`Cannot init audio indicator for ${type}: stream has no live audio tracks.`);
      return;
    }

    this._ensureAudioContext(); // Make sure context exists and is running

    const videoWrapperElement = type === 'local' ? $('#my-own-video-wrapper-call') : $('#my-peer-video-wrapper-call');
    const indicatorElement = type === 'local' ? $('#my-audio-indicator') : $('#peer-audio-indicator');

    if (!videoWrapperElement.length || !indicatorElement.length) {
      console.error(`Cannot init audio indicator for ${type}: wrapper or indicator element not found.`);
      return;
    }

    if (type === 'local') {
      if (this.localAudioIndicator) this.localAudioIndicator.destroy(); // Cleanup old instance if exists
      this.localAudioIndicator = new AudioAnalyserIndicator({
        stream: stream,
        audioContext: this.audioContext,
        videoWrapperElement: videoWrapperElement,
        indicatorElement: indicatorElement,
        speakingThreshold: this.speakingThreshold
      });
    } else if (type === 'peer') {
      if (this.peerAudioIndicator) this.peerAudioIndicator.destroy(); // Cleanup old instance if exists
      this.peerAudioIndicator = new AudioAnalyserIndicator({
        stream: stream,
        audioContext: this.audioContext,
        videoWrapperElement: videoWrapperElement,
        indicatorElement: indicatorElement,
        speakingThreshold: this.speakingThreshold
      });
    }
  }

  /**
   * Creates an empty video track using a canvas element.
   * The track is stored in this._myDummyTrack for later use in streams.
   */
  _createEmptyVideoTrack() {
    try {
      // Create a canvas element with small 16:9 ratio to save bandwidth
      // Using a very small resolution since this is just a dummy track
      const canvas = document.createElement('canvas');
      canvas.width = 160;  // Very small width
      canvas.height = 90;  // 16:9 ratio

      // Get the canvas context and fill with a black background
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#000000';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // No need for text or fancy graphics since this is just a dummy
      // that won't be displayed to users

      // Create a stream from the canvas with very low frame rate to save bandwidth
      let canvasStream;
      try {
        // Use very low FPS to minimize bandwidth usage
        canvasStream = canvas.captureStream(1); // Just 1 FPS
      } catch (e) {
        // Fallback for older browsers
        canvasStream = canvas.captureStream();
      }

      // Make sure we have video tracks
      if (canvasStream && canvasStream.getVideoTracks().length > 0) {
        // This will be a CanvasCaptureMediaStreamTrack
        this._myDummyTrack = canvasStream.getVideoTracks()[0];

        // Apply constraints to reduce quality and bitrate
        if (this._myDummyTrack.applyConstraints) {
          this._myDummyTrack.applyConstraints({
            width: 160,
            height: 90,
            frameRate: 1,
            bitrate: 10000 // Very low bitrate (10 Kbps)
          }).catch(e => console.error('Error applying constraints to dummy track:', e));
        }

        // Keep the context and canvas for animation if needed
        this._canvasElement = canvas;
        this._canvasContext = ctx;

        console.log('Low-bandwidth empty video track created successfully', this._myDummyTrack);
        console.log('Track type:', this._myDummyTrack.constructor.name);

      } else {
        console.error('Failed to get video tracks from canvas stream');
      }
    } catch (error) {
      console.error('Error creating empty video track:', error);
    }
  }

  muteLocalMic() {
    if (this.isMicMuted) {
      return;
    }
    this.isMicMuted = true;

    if (this._local1on1Stream) {
      const audioTracks = this._local1on1Stream.getAudioTracks();
      audioTracks.forEach(track => {
        track.enabled = false;
      });

      // Update user data
      this.socket.updateUserData({ 'userAudioMuted': true });

      console.log('Local microphone muted');
    }
  }

  unmuteLocalMic() {
    if (!this.isMicMuted) {
      return;
    }
    this.isMicMuted = false;

    if (this._local1on1Stream) {
      const audioTracks = this._local1on1Stream.getAudioTracks();
      audioTracks.forEach(track => {
        track.enabled = true;
      });

      // Update user data
      this.socket.updateUserData({ 'userAudioMuted': false });

      console.log('Local microphone unmuted');
    }
  }

  turnOffLocalCamera() {
    if (this.isCameraOff) {
      return;
    }
    this.isCameraOff = true;

    if (this._local1on1Stream) {
      const videoTracks = this._local1on1Stream.getVideoTracks();
      videoTracks.forEach(track => {
        track.enabled = false;
      });

      // Update user data
      this.socket.updateUserData({ 'userVideoMuted': true });

      console.log('Local camera turned off');
    }
  }

  turnOnLocalCamera() {
    if (!this.isCameraOff) {
      return;
    }
    this.isCameraOff = false;

    if (this._local1on1Stream) {
      const videoTracks = this._local1on1Stream.getVideoTracks();
      videoTracks.forEach(track => {
        track.enabled = true;
      });

      // Hide avatar when camera is on
      $("#own-avatar-call").hide();

      // Update user data
      this.socket.updateUserData({ 'userVideoMuted': false });

      console.log('Local camera turned on');
    }
  }

  _errorHandler = (error) => {
    console.error(error);
  }

  _isScreenShareActive() {
    return this._isSharingScreen || this._isReceivingScreenSharing
  }

  _applyCallView(view) {
    this._callView = view
    this.model.oneOnOneCallView = view
    this.callContainer.applyCallView(view)
    CallMinimizeButton.toggleMinimized(this._callViewBeforeScreenShare === CALL_VIEW.MINIMIZED)
  }

  enterMinimizedView() {
    this._callViewBeforeScreenShare = CALL_VIEW.MINIMIZED
    this._applyCallView(this._isScreenShareActive() ? CALL_VIEW.SCREENSHARE : CALL_VIEW.MINIMIZED)
  }

  enterStandardView() {
    this._callViewBeforeScreenShare = CALL_VIEW.STANDARD
    this._applyCallView(this._isScreenShareActive() ? CALL_VIEW.SCREENSHARE : CALL_VIEW.STANDARD)
  }

  enterScreenShareView() {
    if (this._callView !== CALL_VIEW.SCREENSHARE) {
      this._callViewBeforeScreenShare = this._callView
    }
    this._applyCallView(CALL_VIEW.SCREENSHARE)
  }

  exitScreenShareView() {
    this._applyCallView(this._callViewBeforeScreenShare)
  }

  resetCallView() {
    this._callViewBeforeScreenShare = CALL_VIEW.STANDARD
    this._applyCallView(CALL_VIEW.STANDARD)
  }

  /**
   * Starts screen sharing.
   */
  async startScreenSharing() {
    if (!this.peer) {
      console.log('Cannot start screen sharing: No active peer connection');
      return;
    }

    if (this._isSharingScreen) {
      console.log('Screen sharing already in progress');
      return;
    }

    // Check if the peer is already sharing their screen
    if (this._isReceivingScreenSharing) {
      console.log('Peer is already sharing their screen');
      this.model.alert('error', $trans('error-screen-sharing-in-progress'));
      return;
    }

    try {
      // Get screen sharing stream
      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: {
          cursor: "always"
        },
        audio: false // No need for audio from screen
      })

      // Store screen stream for later reference
      this._myScreenStream = screenStream;
      const screenVideoTrack = screenStream.getVideoTracks()[0];
      this._isSharingScreen = true;

      // Add ended event listener to handle when user stops sharing via browser UI
      screenVideoTrack.addEventListener('ended', () => {
        console.log('Screen sharing ended via browser UI');
        this.stopScreenSharing();
      });

      // Find the sender that's currently sending our video track
      const senders = this.peer._pc.getSenders();
      const videoSender = senders.find(sender => sender.track?.id === this._myDummyTrack.id);
      if (!videoSender) {
        console.error('No video sender found to replace track');
        this.stopScreenSharing();
        return
      }

      console.log('Replacing video track with screen sharing track');

      // Replace the track with screen sharing track
      try {
        await videoSender.replaceTrack(screenVideoTrack)

        console.log('Successfully replaced track with screen sharing')

        // Display own screen in UI
        this.callContainer.setShareVideoStream(this._myScreenStream)

        // Update UI
        this.enterScreenShareView()
        CallScreenSharingButton.toggleSelected(true)
      } catch (err) {
        console.error('Error replacing track:', err);
        this.stopScreenSharing();
      }

      // Send the dummy track ID to peer for identification if needed
      this.socket.getSocketWhenReady().then(() => {
        this.socket.getSocket().emit('screenShareStarted', {
          dummyTrackId: this._myDummyTrack.id,
          screenTrackId: screenVideoTrack.id,
          from: this.me,
          to: this.peerInfo.socketId,
          isScreenSharing: true
        });
      })
    } catch (err) {
      console.error('Error starting screen sharing:', err);
      CallScreenSharingButton.toggleSelected(false);
    }
  }

  /**
   * Stops screen sharing.
   */
  stopScreenSharing() {
    if (!this._isSharingScreen) {
      return;
    }

    console.log('Stopping screen sharing');
    this._isSharingScreen = false;

    // Force exit fullscreen if active
    this.exitScreenShareFullscreen();

    const myScreenTrack = this._myScreenStream?.getVideoTracks()[0];

    // Revert to the determined track
    if (this.peer && this._myDummyTrack && myScreenTrack) {
      const senders = this.peer._pc.getSenders();
      const videoSender = senders.find(sender => sender.track?.id === myScreenTrack.id);
      if (videoSender) {
        console.log('Reverting to original video track');
        videoSender.replaceTrack(this._myDummyTrack)
          .then(() => console.log('Successfully reverted to original track'))
          .catch(err => console.error('Error reverting to original track:', err));
      }
    }

    // Stop screen sharing stream
    if (this._myScreenStream) {
      this._myScreenStream.getTracks().forEach(track => track.stop());
      this._myScreenStream = null;
    }

    // Update UI
    this.callContainer.setShareVideoStream(null);
    this.exitScreenShareView();
    CallScreenSharingButton.toggleSelected(false);

    // Notify peer about stopping screen share
    this.socket.getSocket().emit('screenShareStopped', {
      to: this.peerInfo?.socketId,
      from: this.me,
      isScreenSharing: false
    });
  }

  exitScreenShareFullscreen() {
    exitFullscreen();
  }

  /**
   * Handle video call response logic
   * @param {Event} e - The click event
   */
  async handleVideoCallResponse(e) {
    if (this.pendingOfflineCall && !(this.call && this.call.signal)) {
      const io = this.socket.getSocket();
      if (io) {
        this.waitingSignalForCallId = this.pendingOfflineCall.callId;
        io.emit('personalCallAccept', { callId: this.pendingOfflineCall.callId });
      }
      return;
    }
    if (this.model.activeOneOnOneCall) {
      this.model.alert('error', $trans('error-call-already-in-progress'));
      return;
    }
    if (!(await requestMediaPermissions('all', this.model))) {
      return
    }

    // Cleanup meeting mode streams before answering 1:1 call
    if (this.model.streamController) {
      try {
        await this.model.streamController.cleanupAllStreams();
      } catch (error) {
        console.error("Error cleaning up meeting mode streams:", error);
        // Continue anyway to not block 1:1 call answer
      }
    }

    // Cleanup tour mode streams before answering 1:1 call
    if (this.model.tourStreamController) {
      try {
        await this.model.tourStreamController.cleanupAllStreams();
      } catch (error) {
        console.error("Error cleaning up tour mode streams:", error);
        // Continue anyway to not block 1:1 call answer
      }
    }

    this.incomingCallDialog?.hide()
    const $incomingCallDialog = $(e.target).closest('.calling-popup--incoming-call')
    /** @type {IncomingCallDialog} */
    const incomingCallDialog = $incomingCallDialog.data('controller')
    this.peerInfo = incomingCallDialog.senderInfo
    const callData = {
      withAudio: incomingCallDialog.data.withSound,
      withVideo: incomingCallDialog.data.withCamera,
      scopeId: incomingCallDialog.data.scopeId,
      scopeName: incomingCallDialog.data.scopeDisplayName,
      removeElement: $incomingCallDialog.find('.call_unique_class').val(),
    }

    this.callContainer.displayCallOverlay();
    this.model.hideLoading();
    const constraints = {
      cameraDevice: $('#settings_camera').val(),
      microphoneDevice: $('#settings_microphone').val()
    }
    await this.start(
      'users',
      callData.scopeId,
      callData.scopeName,
      callData.withCamera,
      callData.withAudio,
      constraints,
      callData.removeElement,
      null,
      () => {
        this.answerCall();
      }
    );
    this.model.activeOneOnOneCall = true;
    this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE });
  }

  /**
   * Answer incoming call
   */
  answerCall() {
    ///TODO_WEBRTC
    // webrtc.leaveRoom();
    this.model.hideLoading();
    this.model.dispatchEvent({ type: WEBRTC_EVENTS.ANSWER_CALL, });

    if (this.peer) {
      this.peer = null;
    }
    const stream = this._local1on1Stream;
    const currentTracks = stream.getTracks();
    const hasEmptyTrack = currentTracks.some(track => track.id === this._myDummyTrack?.id);
    if (this._myDummyTrack && !hasEmptyTrack) {
      console.log('Adding empty video track to stream in answerCall');
      try {
        stream.addTrack(this._myDummyTrack);
      } catch (e) {
        console.error('Error adding empty track to stream:', e);
      }
    }

    const peer = new SimplePeer({
      initiator: false,
      trickle: false,
      stream,
      config: { iceServers: this.iceServers }
    });
    peer.on('signal', (data) => {
      this.socket.getSocket().emit('answerCall', { signal: data, to: this.call.from });
    });
    peer.on('stream', (currentStream) => {
      console.log('[answerCall] Receive stream ', currentStream)

      this._peerCompositeStream = currentStream;

      this.callContainer.setPeerVideoStream(currentStream, {
        callback: (videoElement) => {
          this._initAudioIndicator('peer', currentStream);
        }
      })
    });
    peer.on('close', () => {
      if (this.model.activeOneOnOneCall) {
        this.hangUpCall(true, true);
      }
    });

    peer.signal(this.call.signal);
    this.peer = peer;
    this.model.hideLoading();
    this.model.activeOneOnOneCall = true;
    this.model.dispatchEvent({ type: ONE_ON_ONE_UI.UI_CHANGE });
    this.model.socket.updateOneOnOneStatus({ 'userVideoOn': this.model.userWantsCamera, 'on1on1Call': true })
    this.setCallAccepted();
    this.callContainer.displayCallOverlay();
  }

  /**
   * Set call accepted state
   */
  setCallAccepted() {
    this.inCall = true;
  }
}
